module.exports = __webpack_public_path__ + "static/media/Pillnotes_Home_Jason.a4ab1fa4.png";


//////////////////
// WEBPACK FOOTER
// ./src/LandingPage/images/Pillnotes_Home_Jason.png
// module id = 1447
// module chunks = 0